import { api } from '../api/client';

export type GuideStatus = 'PUBLISHED' | 'DRAFT' | 'CHANGES_REQUESTED';

export type GuideSummary = {
  slug: string;
  title: string;
  category: string;
  order: number;
  summary: string;
  status: GuideStatus;
  reviewedBy: string | null;
  reviewedRole: string | null;
  reviewedAt: string | null;
};

export type GuideReview = {
  decision: 'APPROVED' | 'CHANGES';
  reviewerName: string;
  reviewerRole: string;
  note: string | null;
  createdAt: string;
  currentVersion: boolean;
};

export type GuideView = {
  guide: GuideSummary;
  body: string;
  reviewerNotes: string | null;
  canReview: boolean;
  history: GuideReview[];
};

export type GuideList = { reviewer: boolean; canReview: boolean; guides: GuideSummary[] };

export const CATEGORIES: { id: string; title: string }[] = [
  { id: 'understanding', title: 'Understanding autism' },
  { id: 'teaching', title: 'Teaching new skills' },
  { id: 'everyday', title: 'Everyday life' },
  { id: 'evidence', title: 'What the research says' },
  { id: 'uk-support', title: 'Support, school and your rights' },
];

export const STATUS_LABEL: Record<GuideStatus, string> = {
  PUBLISHED: 'Published',
  DRAFT: 'Waiting for review',
  CHANGES_REQUESTED: 'Changes asked for',
};

export function fetchGuides(): Promise<GuideList> {
  return api<GuideList>('/guides', { token: true });
}

export function fetchGuide(slug: string): Promise<GuideView> {
  return api<GuideView>(`/guides/${encodeURIComponent(slug)}`, { token: true });
}

export function reviewGuide(slug: string, decision: 'APPROVED' | 'CHANGES', note: string): Promise<GuideView> {
  return api<GuideView>(`/guides/${encodeURIComponent(slug)}/review`, {
    method: 'POST',
    token: true,
    body: { decision, note },
  });
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
}
